import { BackgroundRemoverTool } from '@/components/BackgroundRemoverTool';

const BackgroundRemoverPage = () => {
  return <BackgroundRemoverTool />;
};

export default BackgroundRemoverPage;
